import authorizationService from '../../common/services/security/authorizationService';
import { setLoggedInUserSucceeded } from './loggedInUserSlice';
import loggedInUserMapper from '../../common/services/security/loggedInUserMapper';

export const setLoggedInUserThunk = () => async dispatch => {
  const jwtToken = authorizationService.getDecodedApplicationToken();
  const setLoggedInUser = loggedInUserMapper.map(jwtToken);
  dispatch(setLoggedInUserSucceeded(setLoggedInUser));
};
